// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._19pkx0bf{margin-top:var(--ds-space-negative-100,-8px)}\n._1o9zkb7n{flex-shrink:1}\n._i0dlf1ug{flex-basis:0%}", ""]);
// Exports
module.exports = exports;
